import React, { Component } from 'react'
import { MediumBtn } from '../Regular/index'
import { port, post } from '../../service/index'
import { connect } from 'react-redux'

class InputChat extends Component {
  constructor(props) {
    super(props)

    this.state = {
      comment: '',
    }
  }

  static contextTypes = {
    router: () => true,
  }
  render() {
    let { conference_id, onClick } = this.props;

    return (
      <div className='chat-input' >
        <div className='card' >
          <div style={{ display: 'flex', width: '100%', alignItems: 'center', marginTop: 10 }} >
            <img src={require('../../assets/icon/arrow_blue.png')} style={{ marginLeft: 10, marginRight: 10, width: 10, height: 10 }} onClick={this.context.router.history.goBack} />
            <a onClick={this.context.router.history.goBack} >กลับไปยังหน้าหลัก</a>
          </div>
          <p className='chat-title' > แสดงความเห็น </p>
          <div className='chat-textarea' >
            <textarea className='textarea' rows='4' style={{ paddingLeft: 10, paddingRight: 10 }} onChange={this._onChange} name='comment' />
          </div>

          <div className='chat-btn' >
            <MediumBtn onClick={this.handlePost} title='โพสต์' />
          </div>
        </div>
      </div>

    )
  }

  _onChange = event =>
    this.setState({ [event.target.name]: event.target.value })

  handlePost = async () => {
    const { comment } = this.state;
    const { id } = this.props.match.params
    const { user_id } = this.props.login.user

    let obj = {
      comment: comment,
      comment_sub_id: id,
      user_comment_id: user_id
    }
    try {
      const { token } = this.props.login.user
      const data = await post('/comment', obj, token)
      window.location.reload()
    } catch (err) {
      console.log(err)
    }
  }
}
const mapStateToProps = (state) => ({
  login: state.login
})

export default connect(mapStateToProps)(InputChat)


// WEBPACK FOOTER //
// ./src/components/Chat/InputChat.js